import React from "react";
import { DialogTitle, DialogContent, IconButton, Typography, Grid, Box, Button, useTheme, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from '@mui/icons-material/Business';
import { useNavigate } from "react-router-dom";
import HandshakeIcon from '@mui/icons-material/Handshake';
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import PageLang from "../../../config/page.languge";
import { clearAgencyFormData } from "../../../redux/reducer/registration/ImplementationAgencySlice";
import useResponsive from "../../../hooks/useResponsive";
import { NAVIGATE_AUTH } from "../../../constant";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { closeDialog } from "../../../redux/reducer/dialogSlice";
import { clearDonorForm } from "../../../redux/reducer/registration/DonorIndivisalSlice";
import { clearFormData } from "../../../redux/reducer/registration/GovernmentSlice";
import { resetMailVerification } from "../../../redux/reducer/regMailVerifySlice";
import { AccountBalance } from "@mui/icons-material";


const RegisterDialog: React.FC = () => {
    const theme = useTheme();
    const lang = useSelector((state: RootState) => state.lang.language);
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { isMobile } = useResponsive()

    const iconStyle = {
        width: 35,
        height: 35,
        mb: 0.5,
        color: theme.palette.primary.main,
    };

    const icons: Record<string, JSX.Element> = {
        BusinessIcon: <BusinessIcon sx={{ ...iconStyle }} />,
        HandshakeIcon: <HandshakeIcon sx={{ ...iconStyle }} />,
        AccountBalanceIcon: <AccountBalance sx={{ ...iconStyle }} />,
        HospitalIcon: <LocalHospitalIcon sx={{ ...iconStyle }} />
    };

    const handleDialog = (url: string) => {
        dispatch(closeDialog());
        localStorage.removeItem('trace_id');
        dispatch(clearAgencyFormData());
        dispatch(clearDonorForm())
        dispatch(clearFormData())
        dispatch(resetMailVerification())
        navigate(url);
    };


    const handleNavigate = () => {
        dispatch(closeDialog());
        navigate(NAVIGATE_AUTH.LOGIN_PAGE)
    }

    const circleStyle = {
        width: 120,
        height: 120,
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.light,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        border: `2px solid ${theme.palette.primary.main}`,
        cursor: "pointer",
        color: "#013E5E",

        "&:hover": {
            border: `2px solid ${theme.palette.warning.light}`,
            boxShadow: `1px 1px 5px 1px ${theme.palette.warning.light}`,
            color: "green"
        },

    };

    return (
        <Box>
            <DialogTitle sx={{ textAlign: "center", position: "relative" }}>
                <Box sx={{ textAlign: "center", mt: 2, mb: 3 }} display={'flex'} justifyContent="center" alignItems="center" flexDirection="column">
                    <Typography variant="h2" fontWeight="bold" color="primary">
                        {PageLang?.RegisterDialog?.Title[lang]}
                    </Typography>
                    <Divider sx={{ height: 4, width: 120, mt: 1, borderRadius: 2, background: `linear-gradient(to right, ${theme.palette.warning.dark}, ${theme.palette.warning.light})`, }} />
                </Box>
                <IconButton onClick={() => dispatch(closeDialog())} sx={{ position: "absolute", right: 10, top: 10 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={isMobile ? 2 : 1} justifyContent="center">
                    {PageLang?.RegisterDialog?.DialogOptions.map(({ key, url, icon, ...labels }) => (
                        <Grid item xs={isMobile ? 6 : 3} key={key}>
                            <Box sx={{ ...circleStyle, m: 2 }} onClick={() => handleDialog(url)}>
                                {icons[icon]}
                                <Typography sx={{ width: 100, fontWeight: 600, color: theme.palette.primary.main }}>{labels[lang]}</Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <Box sx={{ textAlign: "center", mb: 3 }} display={'flex'} justifyContent="center">
                <Button variant="text" color="primary" sx={{ fontWeight: 550 }} onClick={() => handleNavigate()}>
                    {PageLang?.RegisterDialog?.DialogFooter[lang]}
                </Button>
            </Box>
        </Box >
    );
};

export default RegisterDialog;
